import { Disciplines } from '../../domain';

export default function getDisabledProps(discipline?: Disciplines) {
  switch (discipline) {
    case Disciplines.ArenaCourseHire:
      return [
        'eaClassEntrySectionName',
        'bridleNumber',
        'dressageTime',
        'showJumpingTime',
        'drawnOrder',
      ];
    case Disciplines.Dressage:
    case Disciplines.EventerTrial:
      return ['showJumpingTime', 'drawnOrder'];
    case Disciplines.TrainingClinics:
    case Disciplines.XCCourseHire:
      return ['bridleNumber', 'drawnOrder'];
    case Disciplines.Showjumping:
      return [];
    default:
      return ['drawnOrder'];
  }
}
